import React from 'react';
import { Loader2, AlertCircle } from 'lucide-react';

interface DataStateMessageProps {
  loading?: boolean;
  empty?: string | null;
  emptyHint?: string;
  emptyIcon?: React.ReactNode;
}

export const DataStateMessage: React.FC<DataStateMessageProps> = ({
  loading = false,
  empty = null,
  emptyHint,
  emptyIcon,
}) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center gap-2 px-4 py-12 text-[12px] font-medium text-[#64748b]">
        <Loader2 size={14} className="animate-spin" />
        Đang tải...
      </div>
    );
  }
  if (empty) {
    return (
      <div className="flex flex-col items-center gap-2 px-5 py-12 text-[#334155]">
        {emptyIcon ?? <AlertCircle size={32} className="text-[#252a38]" />}
        <p className="text-[14px] font-semibold text-[#475569]">{empty}</p>
        {emptyHint && <span className="text-[12px] text-[#334155]">{emptyHint}</span>}
      </div>
    );
  }
  return null;
};
